// extracted by mini-css-extract-plugin
export default {"Container":"Sensor_Container__83WAz"};